import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, OnInit, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'sera-input-number',
    templateUrl: './sera-input-number.component.html',
    styleUrls: ['./sera-input-number.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraInputNumberComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraInputNumberComponent extends ValueAccessor<number> implements OnInit {
    // When declaring this component try always to declare inputId and name
    @Input()
    inputId!: string;

    @Input()
    inputStyleClass!: string;

    @Input()
    name!: string;

    @Input()
    maxFractionDigits: number = 1;

    @Input()
    minFractionDigits!: number;

    @Input()
    placeholder!: string;

    @Input()
    format = true;

    @Input()
    showButtons = false;

    @Input()
    showClear = false;

    @Input()
    allowEmpty = true;

    @Input()
    mode: string = 'decimal';

    @Input()
    isDisabled: boolean = false;

    @Input()
    required: boolean = false;

    @Input()
    readOnly: boolean = false;

    @Input()
    style: {} = {};

    @Input()
    inputStyle!: {};

    @Input()
    styleClass!: string;

    @Input()
    min!: number;

    @Input()
    max: number | null = null;

    @Input()
    maxlength!: number;

    @Input()
    autoWidth: boolean = false;

    /* float label configuration */
    @Input()
    label: string | undefined;

    @Input()
    icon: string | undefined;

    @Input()
    styleFloatLabel: string = '';

    @Input()
    numberClassContainer: string = '';

    //If you wish to use left you have to style the input
    @Input()
    iconSide: string = 'right';
    /* float label configuration */

    @Input()
    numberPipeFractionDigits!: number;

    @Output() inputNumberChange = new EventEmitter<number>();

    @Output() inputNumberBlur = new EventEmitter<number>();

    @Output() inputNumberFocus = new EventEmitter<number>();

    @Output() inputNumberClear = new EventEmitter<number>();

    emitInputNumberChange(value: number): void {
        this.inputNumberChange.emit(value);
    }

    emitInputNumberBlur(value: number): void {
        this.inputNumberBlur.emit(value);
    }

    emitInputNumberFocus(value: number): void {
        this.inputNumberFocus.emit(value);
    }

    emitInputNumberClear(value: number): void {
        this.inputNumberClear.emit(value);
    }

    constructor(injector: Injector) {
        super(injector);
    }
    ngOnInit(): void {
        this.icon ? this.iconSideClass() : '';
    }

    iconSideClass(): void {
        this.iconSide === 'left' ? (this.styleFloatLabel += 'p-input-icon-left ') : (this.styleFloatLabel += 'p-input-icon-right ');
    }
}
